/**
 * `/market/publishers/$handle` — one seller's shelf (G6).
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/publishers/$handle')({});
